import React from 'react'
import posthog from 'posthog-js'
import { PostHogProvider } from '@posthog/react'
import { PrivacyNoticeBanner } from './pages-impl/PrivacyNoticeBanner'

const POSTHOG_API_KEY =
  typeof window !== 'undefined'
    ? process.env.GATSBY_PUBLIC_POSTHOG_KEY
    : undefined
const POSTHOG_HOST =
  typeof window !== 'undefined'
    ? process.env.GATSBY_PUBLIC_POSTHOG_HOST
    : undefined

if (POSTHOG_API_KEY) {
  posthog.init(POSTHOG_API_KEY, {
    api_host: POSTHOG_HOST || 'https://eu.i.posthog.com',
    defaults: '2025-11-30',
    capture_pageview: 'history_change', // Track route-changes as pageviews
    capture_pageleave: true,
    cookieless_mode: 'on_reject', // GDPR: no cookies until user consents
  })
}

export function App({ children }: { children: React.ReactNode }) {
  return (
    <PostHogProvider client={posthog}>
      {children}
      <PrivacyNoticeBanner />
    </PostHogProvider>
  )
}
